import React from 'react';
import Text from './fields/text';
import Number from './fields/number';
import Select from './fields/select';
import Map from './fields/map';
import List from './fields/list';
import SortList from './fields/sortList';

const fields = {
    string: Text,
    integer: Number,
    enum: Select,
    map: Map,
    list: List,
    sortlist: SortList,
};


const FieldsFactory = fieldProp => {
    const CurrentField = fields[fieldProp.type.toLowerCase()];
    return (<CurrentField {...fieldProp}/>);
};

export default FieldsFactory;
